import { render } from "./AccountMain.vue?vue&type=template&id=b61b6594&ts=true"
import script from "./AccountMain.vue?vue&type=script&lang=ts"
export * from "./AccountMain.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__